var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDues(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13_1357",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13_1357)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3636 16.5C10.7821 16.5 9.5 17.7821 9.5 19.3636V45.5455C9.5 47.127 10.7821 48.4091 12.3636 48.4091H51.6364C53.2179 48.4091 54.5 47.127 54.5 45.5455V19.3636C54.5 17.7821 53.2179 16.5 51.6364 16.5H12.3636ZM6.5 19.3636C6.5 16.1252 9.12524 13.5 12.3636 13.5H51.6364C54.8748 13.5 57.5 16.1252 57.5 19.3636V45.5455C57.5 48.7838 54.8748 51.4091 51.6364 51.4091H12.3636C9.12524 51.4091 6.5 48.7838 6.5 45.5455V19.3636Z",
    fill: "#11216C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 28.0909C6.5 27.2625 7.17157 26.5909 8 26.5909H56C56.8284 26.5909 57.5 27.2625 57.5 28.0909C57.5 28.9194 56.8284 29.5909 56 29.5909H8C7.17157 29.5909 6.5 28.9194 6.5 28.0909Z",
    fill: "#11216C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDues);
export default __webpack_public_path__ + "static/media/dues.6443eddd76947f0b3794a210be937350.svg";
export { ForwardRef as ReactComponent };